import { computed } from "vue";
import { useRouter } from "vue-router";

import { useAuth } from "@/hooks/auth";
import { ROUTE_ERC_REPORTS } from "@/router/routes";

import type { IWorkflow } from "@/models/workflows";

export const useERCReports = () => {
  const { currentUser } = useAuth();
  const router = useRouter();

  const assignedWorkflowIds = computed(
    () => currentUser?.permissions_preset?.assigned_workflow_template_ids || []
  );

  const assignedWorkflowTemplates = computed<Array<IWorkflow>>(() => {
    return (currentUser?.permissions_preset?.assigned_workflow_templates ||
      []) as Array<IWorkflow>;
  });

  const assignedWorkflowTemplateNames = computed(() => {
    return assignedWorkflowTemplates.value.map(
      (workflowTemplate) => workflowTemplate.name
    );
  });

  const getWorkflowTemplateName = (workflowTemplateId: string) => {
    const workflowTemplate = assignedWorkflowTemplates.value.find(
      (workflowTemplate) => workflowTemplate.id === workflowTemplateId
    );
    return workflowTemplate?.name || "";
  };

  const getWorkflowTemplateId = (workflowTemplateName: string) => {
    const workflowTemplate = assignedWorkflowTemplates.value.find(
      (workflowTemplate) => workflowTemplate.name === workflowTemplateName
    );
    return workflowTemplate?.id || "";
  };

  const goToErcReportFor = async (workflowTemplateId: string) => {
    await router.push({
      name: ROUTE_ERC_REPORTS,
      params: {
        workflowTemplateId,
      },
    });
  };

  return {
    assignedWorkflowIds,
    assignedWorkflowTemplateNames,
    assignedWorkflowTemplates,
    getWorkflowTemplateName,
    getWorkflowTemplateId,
    goToErcReportFor,
  };
};
